// Manager records shown as rows in the Members grid, alongside the members.
//
// Member ids and manager ids are separate id spaces and can hold the same number, so each
// row carries its own key; `isManagerRecord` is what tells the activities panel below the
// grid to ask for the manager's own work rather than a member's.
// @since NEXT_VERSION
export const toManagerGridRows = (managers) =>
  (Array.isArray(managers) ? managers : []).filter(Boolean).map((manager) => ({
    rowKey: `mgr-${manager.id}`,
    id: manager.id,
    name: manager.name,
    email: manager.clientEmail,
    client: { id: manager.clientId, code: manager.clientCode, name: manager.clientName },
    isManagerRecord: true,
  }));

export default toManagerGridRows;
